import Axios from "axios";
import { adminApi } from "../config";

const endpoint = "/analytics";

export const getEntityStats = async () => {
  try {
    let url = `${endpoint}/stats`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};
